import * as actionTypes from "../constants/actionTypes";
import * as modelHelper from "../helpers/modelHelper";
import * as componentTypes from "../constants/componentTypes";

const initialState = {
    allBatchNumbersList: {},
    batchesByColorant: [],
    messageCodeList: null,
    reconnectMachine: false,
    refillHistory: [],
    ufiCodeList: []
};

/**
 * Structure of batchesByColorant store:
 * - batchesByColorant {Array}
 * - messageCodeList {Object | null}
 * - reconnectMachine {Boolean}
 * - refillHistory {Array}
 * - ufiCodeList {Array}
 */
export const machineReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.CLOSE_ACTIVE_TAB:
        case actionTypes.CLOSE_ALL_TABS:
            if (!action.payload.newTabList.some((item) => item.type === componentTypes.CANISTERS_TAB)) {
                return {
                    ...state,
                    ufiCodeList: []
                };
            }

            return state;
        case actionTypes.COLORANT_REFILL_HISTORY_EXIT:
            return {
                ...state,
                refillHistory: []
            };
        case actionTypes.MACHINE_SAVE_DRIVER_RECONNECT:
            return {
                ...state,
                reconnectMachine: action.payload.reconnectMachine
            };
        case actionTypes.RCC_WEBSOCKET_CLOSED:
            return {
                ...state,
                batchNumbersList: [],
                messageCodeList: null,
                refillHistory: [],
                ufiCodeList: []
            };
        case actionTypes.SAVE_BATCHES_BY_COLORANT:
            return {
                ...state,
                batchesByColorant: action.payload.data.map(modelHelper.mapColorantBatchNumberToObject)
            };
        case actionTypes.SAVE_MACHINE_ALL_BATCH_NUMBERS:
            return {
                ...state,
                allBatchNumbersList: action.payload.batchNumbers
            };
        case actionTypes.SAVE_CANISTER_UFI_CODES:
            return {
                ...state,
                ufiCodeList: action.payload.data
            };
        case actionTypes.SAVE_MACHINE_MESSAGE_CODES:
            return {
                ...state,
                messageCodeList: action.payload.messageCodeList
            };
        case actionTypes.SAVE_MACHINE_REFILL_HISTORY:
            return {
                ...state,
                refillHistory: modelHelper.mapHistoryRecordsToObjects(action.payload.data)
            };
        case actionTypes.SAVE_MACHINE_REFILL_HISTORY_WITH_OFFSET:
            return {
                ...state,
                refillHistory: state.refillHistory.concat(modelHelper.mapHistoryRecordsToObjects(action.payload.data))
            };

        default:
            return state;
    }
};
